
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Bluedots from '../../assets/images/blue_dotes.png';
import PlanCard from './PlanCard';
import { plansApi } from '../../services/api';
import logger from '../../utils/logger';

function Pricing() {
  const [tabMenu, tabActive] = useState({ a: true });
  const [plans, setPlans] = useState([]);
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const [plansRes, featuresRes] = await Promise.all([
          plansApi.fetchAllPlans(),
          plansApi.fetchAllFeatures(),
        ]);

        // Handle response structure - API returns { data: [...] }
        const plansArray = Array.isArray(plansRes) ? plansRes : (plansRes?.data || []);
        const featuresArray = Array.isArray(featuresRes) ? featuresRes : (featuresRes?.data || []);
        
        setPlans(plansArray);
        setFeatures(featuresArray);
      } catch (error) {
        logger.error('Failed to load pricing data', error);
        setPlans([]);
        setFeatures([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const renderPlans = (isYearly) => {
    if (!Array.isArray(plans) || plans.length === 0) {
      return <div className="col-12"><p>No plans available</p></div>;
    }
    
    return plans.map(plan => (
      <PlanCard key={plan.id} plan={plan} features={features} isYearly={isYearly} />
    ));
  };

  if (loading) {
    return (
      <section className="row_am pricing_section white_text">
        <div className="container">
          <p>Loading plans...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="row_am pricing_section white_text" data-aos="fade-in" data-aos-duration={1500}>
      <div className="pricing_inner">
        <div className="container">
          <div className="dotes_blue">
            <img src={Bluedots} alt="image" />
          </div>
          <div className="section_title" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={300}>
            <span className="title_badge">Planuri</span>
            <h2>Alege-ți pachetul care ți se <span>potrivește</span></h2>
          </div>
          <ul className="nav nav-tabs" id="myTab" role="tablist" data-aos="fade-up" data-aos-duration={1500}>
            <li className="nav-item" role="presentation">
              <button className={`nav-link ${tabMenu.a && "active"}`} onClick={() => tabActive({ a: true })}>
                Lunar
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button className={`nav-link ${tabMenu.b && "active"}`} onClick={() => tabActive({ b: true })}>
                Anual
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div className={`tab-pane fade ${tabMenu.a && "show active"}`} id="monthly">
              <div className="pricing_pannel">
                <div className="row">{renderPlans(false)}</div>
              </div>
            </div>
            <div className={`tab-pane fade ${tabMenu.b && "show active"}`} id="yearly">
              <div className="pricing_pannel">
                <div className="row">{renderPlans(true)}</div>
              </div>
            </div>
            <p className="contact_text text-center" data-aos="fade-up" data-aos-duration={1500}>
              *Prețurile nu includ TVA<br /><br />
              Ai întrebări ?<br /><Link to="/contact">Contactează-ne</Link> pentru mai multe detalii
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
